import { SiteModel } from "@/models/site.model";
import store from "@/store";
import Vue from "vue";
import {
  UPDATE_BALANCE_SHEET,
  UPDATE_CURRENT_STEP,
  UPDATE_EACM_EQUIPMENT,
  UPDATE_EAR_EQUIPMENT,
  UPDATE_IS_EAR_MANDATORY,
  UPDATE_MANDATORY_EXTRACTOR,
  UPDATE_MANDATORY_EXTRACTOR_COUNT,
  UPDATE_OPTIONAL_EACM_EQUIPMENT,
  UPDATE_OPTIONAL_EACM_SITES,
  UPDATE_OPTIONAL_EXTRACTOR,
  UPDATE_OPTIONAL_EXTRACTOR_COUNT,
  UPDATE_SECURITY_EXTRACTOR_ENABLED,
  UPDATE_SETTINGS,
  UPDATE_SITE_MODEL,
} from "@/store/operators";
import { BalanceSheetModel } from "@/models/balanceSheet.model";
import { Settings } from "@/models/settings.model";
import EquipmentsStore from "@/store/modules/equipment.store";
import { saveAs } from "file-saver";
import { AbacaExportModel, EquipmentExportModel } from "@/models/abaca.model";
import { http } from "./https.service";
import { ExcelPayload } from "@/models/excelPayload.model";
import { AxiosResponse } from "axios";

export enum ErrorImportType {
  VERSION_ERROR,
  PARSE_ERROR,
}

// feed the store from imported json file
export function importAbacaFromJson(json: AbacaExportModel): void {
  const site: SiteModel = json.site;
  const balanceSheet: BalanceSheetModel = json.balanceSheet;
  const settings: Settings = json.settings;
  const currentStep: number = json.currentStep;
  store.commit(UPDATE_SITE_MODEL, site);
  store.commit(UPDATE_BALANCE_SHEET, balanceSheet);
  store.commit(UPDATE_SETTINGS, settings);
  store.commit(UPDATE_CURRENT_STEP, currentStep);
  importEquipment(json.equipments);
}

// create json from abaca store
export function createJsonFromAbaca(): AbacaExportModel {
  const site: SiteModel = { ...store.state.siteModule.site };
  const settings: Settings = { ...store.state.settingsModule.settings };
  const currentStep: number = store.state.globalAppDataModule.currentStep;
  const version: string = store.state.globalAppDataModule.dataTypeVersion;
  const balanceSheet: BalanceSheetModel = { ...store.state.siteModule.balanceSheet };
  const equipmentStore: EquipmentsStore = { ...store.state.equipmentsModule };
  const json: AbacaExportModel = {
    site: site,
    settings: settings,
    currentStep: currentStep,
    dataTypeVersion: version,
    balanceSheet: balanceSheet,
    equipments: {
      mandatoryExtractor: equipmentStore.mandatoryExtractor,
      optionalExtractor: equipmentStore.optionalExtractor,
      eacmEquipment: equipmentStore.eacmEquipment,
      optionalEacmEquipment: equipmentStore.optionalEacmEquipment, /*Evolution Majeure pour EACM*/
      earEquipment: equipmentStore.earEquipment,
      isSecurityExtractorRequired: equipmentStore.isSecurityExtractorRequired,
      mandatoryExtractorCount: equipmentStore.mandatoryExtractorCount,
      optionalExtractorCount: equipmentStore.optionalExtractorCount,
      optionalEacmsites:equipmentStore.optionalEacmsites, /*Evolution Majeure pour EACM*/
      isEarMandatory: equipmentStore.isEarMandatory,
    },
  };
  return json;
}

// import equipments into the store
export function importEquipment(json: EquipmentExportModel): void {
  store.commit(UPDATE_MANDATORY_EXTRACTOR, json.mandatoryExtractor);
  store.commit(UPDATE_OPTIONAL_EXTRACTOR, json.optionalExtractor);
  store.commit(UPDATE_EACM_EQUIPMENT, json.eacmEquipment);
  store.commit(UPDATE_OPTIONAL_EACM_EQUIPMENT, json.optionalEacmEquipment); /*Evolution Majeure pour EACM*/

  store.commit(UPDATE_EAR_EQUIPMENT, json.earEquipment);
  store.commit(UPDATE_SECURITY_EXTRACTOR_ENABLED, json.isSecurityExtractorRequired);
  store.commit(UPDATE_MANDATORY_EXTRACTOR_COUNT, json.mandatoryExtractorCount);
  store.commit(UPDATE_OPTIONAL_EXTRACTOR_COUNT, json.optionalExtractorCount);
  store.commit(UPDATE_OPTIONAL_EACM_SITES, json.optionalEacmsites); /*Evolution Majeure pour EACM*/

  store.commit(UPDATE_IS_EAR_MANDATORY, json.isEarMandatory);
}

// download abaca file exported data
export function saveFile(fileName: string, json: AbacaExportModel, extension: string): void {
  const data = JSON.stringify(json);
  const exportFileDefaultName = `${fileName}.${extension}`;
  const blob = new Blob([data], {
    type: "application/json; charset=utf-8",
  });

  saveAs(blob, exportFileDefaultName);
}

export function exportToExcel(excelPayload: ExcelPayload): Promise<AxiosResponse<ExcelPayload>> {
  const url: string = Vue.prototype.URL_GetExcel;

  return http.post<ExcelPayload>(url, excelPayload, { responseType: "blob" });
}
